import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalAddUser from "./ModalAddUser";

const useModalAddUser = (onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, mode: 'none', user_id: null })  ;

    const onClickActivate = ( user_id, mode, user_type_id, lock_pref_name ) =>
    {
        setDialog ({ openState: true, user_id: user_id, mode: mode, user_type_id:user_type_id, lock_pref_name:lock_pref_name});
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, user_id: null, key: null, mode: 'none', user_type_id:'none', lock_pref_name:'none'});
    };

    const onSaveComplete = ( result ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, user_id: null, mode: 'none',  user_type_id:'none', lock_pref_name:'none'});

        // Tell the parent we're done
        onSaveCompleted(result) ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalAddUser user_id={dialog.user_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode} user_type_id={dialog.user_type_id} lock_pref_name={dialog.lock_pref_name}/> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalAddUser ;
